import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { TranslateRequest } from './translate.interface';
import { TranslateService } from './translate.service';

const service = new TranslateService();

export interface TranslateState {}

const TranslateStore: Module<TranslateState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async postTranslate(context, payload: TranslateRequest) {
         return await service.postTranslate(payload);
      },
   },
};

export default TranslateStore;
